import { Button, Popconfirm } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

export interface ConfirmDeleteButtonProps {
  readonly title: string;
  readonly description?: string;
  readonly onConfirm: () => void;
  readonly disabled?: boolean;
  // Set when the button sits inside a clickable row, to stop the click selecting/toggling the row.
  readonly stopPropagation?: boolean;
}

// A danger icon-button guarded by an "are you sure" Popconfirm — the shared shape used across the
// roadmap builder (stages, requirements, files) so the confirm + stopPropagation aren't re-inlined.
function ConfirmDeleteButton(props: ConfirmDeleteButtonProps) {
  return (
    <Popconfirm
      title={props.title}
      description={props.description}
      okText="Delete"
      okButtonProps={{ danger: true }}
      onConfirm={props.onConfirm}
    >
      <Button
        type="text"
        size="small"
        danger
        disabled={props.disabled}
        icon={<DeleteOutlined />}
        onClick={props.stopPropagation ? (e) => e.stopPropagation() : undefined}
      />
    </Popconfirm>
  );
}

export default ConfirmDeleteButton;
